module.exports = __webpack_public_path__ + "img/mapstatus_white.bdd76c2d.svg";